import axios, { AxiosError } from 'axios';
import { buildURL } from '../webservice';

// 1. Usamos la nueva URL base de la variable de entorno
const BASE_URL = process.env.REACT_APP_PAYMENTS_API_V2_URL!;

/**
 * Obtiene la lista de bancos utilizando un token de autenticación.
 * @param authToken El token de autenticación obtenido de useAuthStore.
 */
const fetchBanks = async (authToken: string) => {
    try {
        // 2. Construimos la URL del endpoint (asumimos que es /banks)
        const url = buildURL(BASE_URL, '/banks');

        // 3. Configuramos los headers para incluir el token
        const config = {
            headers: {
                // El formato estándar es "Bearer [token]"
                Authorization: `Bearer ${authToken}`,
            },
        };

        // 4. Hacemos la llamada GET al endpoint con la configuración de autenticación
        const response = await axios.get(url, config);

        // 5. Devolvemos los datos (la lista de bancos)
        return response.data;
    } catch (err) {
        console.error('Error al obtener la lista de bancos:', err);
        if (err instanceof AxiosError) {
            // Si hay un error de Axios (ej. 401 Unauthorized), devolvemos un array vacío
            return err.response?.data || [];
        }
        // En caso de error interno inesperado
        return [];
    }
};

export { fetchBanks };
